import React, { ComponentType, useMemo } from "react";
import ExistingCustomerDisplay from "./index";
import { classPrefix, IBaseProps, IContainerProps, IProps } from './types'
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import AdminService from 'external-services/diary-admin-service/admin.service';

const propsKeys = keys<IBaseProps>();
const basePropsKeys: string[] = keys<IBaseProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();

const ThemeWrap = function(all: IContainerProps) {
  const country = useMemo(() => AdminService.getVenue().country, []);
  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IContainerProps;
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  /**
   * Passes all base props from container to component
   */
// @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);
  return ReactUtilsService.containerWrap(
    <ExistingCustomerDisplay
      {...props}
      mode="new"
      layout="wide"
      country={country}
    />, classPrefix
  );
}

const R2AExistingCustomerDisplay: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
];

export default R2AExistingCustomerDisplay
